import type { BucketRollup } from '../types/billValidationTypes';

/**
 * Where the intervals behind a reduced demand figure start.
 *
 * A lookback treatment (bv_treat_max_interval_lookback) charges the highest
 * interval in the window ending at the period's end, `applicable_duration`
 * months long (12 when unstated, as in the SQL). Every other treatment reads the
 * period itself.
 */
export function lookbackFrom(
  rollup: Pick<BucketRollup, 'basis' | 'applicable_duration'> | null,
  periodFrom: string,
  periodTo: string,
): string {
  if (rollup?.basis !== 'bv_treat_max_interval_lookback') return periodFrom;
  const months = Number(/(\d+)\s*month/i.exec(rollup.applicable_duration ?? '')?.[1] ?? 12);
  // Month arithmetic the way Postgres does it: the day clamps to the end of the
  // target month (31 Jul - 3 months = 30 Apr), where Date.setUTCMonth would roll
  // over into 1 May and drop a day from the window.
  const [y, m, d] = periodTo.split('-').map(Number);
  const total = y * 12 + (m - 1) - months;
  const ty = Math.floor(total / 12);
  const tm = total % 12;
  const lastDay = new Date(Date.UTC(ty, tm + 1, 0)).getUTCDate();
  const from = new Date(Date.UTC(ty, tm, Math.min(d, lastDay))).toISOString().slice(0, 10);
  return from < periodFrom ? from : periodFrom;
}
